<template>
  <v-row>
    <v-col cols="12">
      <v-switch
        v-model="value.esconderDados"
        :label="'Esconder dados sensíveis? (' + (value.esconderDados === 'S' ? 'Sim' : 'Não') + ') '"
        :true-value="'S'"
        :false-value="'N'"
        inset
      />
    </v-col>
    <v-col cols="12" md="4">
        <v-text-field label="Nome"
                      dense
                      v-model.trim="value.nome"/>
    </v-col>
    <v-col cols="12" md="4">
        <v-text-field label="Login"
                    dense
                    v-model.trim="value.login"/>
    </v-col>      
    <v-col cols="12" md="4">
      <v-text-field label="CPF"
                    dense
                    placeholder="000.000.000-00"
                    :rules="[
                    this.$validators.string.cpf
                  ]"
                    v-mask="'###.###.###-##'"
                    v-model.trim="value.cpf"/>
    </v-col>
    <v-col cols="12" md="4">
      <v-text-field label="Email"
                    dense
                    :rules="[
                      this.$validators.string.email,
                      v => this.$validators.string.lessThanOrEquals(v, 50),
                    ]"
                    v-model.trim="value.email"/>
    </v-col>
    <v-col v-if="this.nivelUsuarioLogado==='AZT'" cols="12" md="4">
      <lookup-dominio label="Nível de Acesso"
                      :hidden-clear="false"
                      hint="Selecione o Nível de Acesso"
                      v-model="value.nivel"
                      :type="lookups.nivelTodos"/>
    </v-col>
    <v-col v-else-if="this.nivelUsuarioLogado==='GUS'" cols="12" md="4">
      <lookup-dominio label="Nível de Acesso"
                      :hidden-clear="false"
                      hint="Selecione o Nível de Acesso"
                      v-model="value.nivel"
                      :type="lookups.nivelOutros"/>
    </v-col>
    <v-col cols="12" md="4">
      <lookup-dominio label="Status"
                      :hidden-clear="false"
                      hint="Selecione o Status"
                      v-model="value.flgStatus"
                      :type="lookups.status"/>
    </v-col>
  </v-row>
</template>

<script>

import {ItemDeDominio} from "../../../../api/itemsDominio";
import LookupDominio from "../../common/LookupDominio";
import OrderInput from "../../common/OrderInput";
import SearchBox from "../../common/SearchBox";
import {mapGetters} from "vuex";

export default {
  name: "RelatorioUsuarioForm",
  components: {
    SearchBox,
    LookupDominio,
    OrderInput
  },
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      lookups: {
        nivelOutros: ItemDeDominio.NIVEL_ACESSO_USUARIO_OUTROS,
        nivelTodos: ItemDeDominio.NIVEL_ACESSO_USUARIO_TODOS,
        status: ItemDeDominio.STATUS_PADRAO,
      },
    }
  },
  watch: {
  },
  computed: {
    ...mapGetters('auth',['user','isAuthenticated','nivelUsuarioLogado']),
  },
  methods: {
    
  }
}
</script>

<style scoped lang="scss">
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}


</style>